import React from 'react';
import { pxToRem } from '@noths/polaris-client-styles';

import type { BannerProps } from './types';

export const Banner = ({ backgroundColor, children, roundedCorners }: BannerProps) => (
  <div
    data-testid="banner"
    style={{ backgroundColor, borderRadius: roundedCorners ? pxToRem(10) : 0 }}
  >
    {children}
  </div>
);
